module.exports = "<template>${ value | time }</template> ";